import {v4 as uuidv4} from "uuid";

/**
 * Session ID is generated once when this module first loads.
 * All subsequent calls to getSessionId() return the same value,
 * ensuring consistency across the entire application (Redux state, API calls, etc.)
 */
const sessionId = uuidv4();

export const getSessionId = (): string => sessionId;
